import React from 'react';
import { useTranslation } from 'react-i18next';

import { PublicFooter } from '../common/PublicFooter';

import FigoBackground from '../../assets/login/login-background.svg';
import PetCloudBanner from '../../assets/pet-cloud-logo.svg';

import './LoginMobile.css';
import { LANGUAGES_EN_US, LANGUAGES_FR_CA } from '../../i18n';

const LoginMobileCaScreen = () => {
  const { i18n } = useTranslation('loginScreen');
  const tEnglish = i18n.getFixedT(LANGUAGES_EN_US, 'loginScreen');
  const tFrench = i18n.getFixedT(LANGUAGES_FR_CA, 'loginScreen');

  return (
    <div className="Login-mobile">
      <div className="Login-mobile-container">
        <div className="Login-pet-cloud-banner">
          <img alt="" src={PetCloudBanner} />
        </div>

        <img
          alt=""
          className="Login-mobile-figo-background"
          src={FigoBackground}
        />

        <div className="Login-mobile-background-content">
          <h1>{tEnglish('loginMobile.welcome')}</h1>

          <p>{tEnglish('loginMobile.textAppPPU')}</p>

          <h1>{tFrench('loginMobile.welcome')}</h1>

          <p>{tFrench('loginMobile.textAppPPU')}</p>
        </div>

      </div>

      <PublicFooter />
    </div>
  );
};

export { LoginMobileCaScreen };
